
import { Rental } from '../types';
import { mockBikes } from './mockBikes';
import { mockCouriers } from './mockCouriers';

export const mockRentals: Rental[] = Array(30)
  .fill(null)
  .map((_, i) => {
    const startDate = new Date(Date.now() - Math.floor(Math.random() * 30) * 24 * 60 * 60 * 1000);
    const endDate = Math.random() > 0.3 
      ? new Date(startDate.getTime() + Math.floor(Math.random() * 7) * 24 * 60 * 60 * 1000)
      : null;
    
    // Добавляем возможность статуса pending (10% шанс)
    let status: Rental['status'];
    if (endDate) {
      status = Math.random() > 0.1 ? 'completed' : Math.random() > 0.5 ? 'cancelled' : 'pending';
    } else {
      status = Math.random() > 0.9 ? 'pending' : 'active';
    }
    
    const bike = mockBikes[Math.floor(Math.random() * mockBikes.length)];
    const courier = mockCouriers[Math.floor(Math.random() * mockCouriers.length)];
    const rentalNumber = `AR-${(i + 1).toString().padStart(5, '0')}`;
    const startDateStr = startDate.toISOString();
    const endDateStr = endDate?.toISOString() || null;
    
    return {
      id: `rental-${i + 1}`,
      bike_id: bike.id,
      courier_id: courier.id,
      // Добавляем обязательные поля
      start_date: startDateStr,
      end_date: endDateStr,
      status: status,
      // Добавляем совместимые псевдонимы
      bikeId: bike.id,
      courierId: courier.id,
      bikeName: `${bike.model} (${bike.serialNumber})`,
      courierName: courier.name,
      startDate: startDateStr,
      endDate: endDateStr,
      cost: Math.floor(200 + Math.random() * 800),
      human_number: rentalNumber,
    };
  });
